<template>
  <div class="hello" id="index">
    <!-- <h2>{{ msg + ' ' + last_time + 's'}}</h2> -->
    <h2>{{msg}}</h2>
  </div>
</template>

<script>
export default {
  mounted(){
  	// let itv = setInterval(()=>{
  	// 	this.last_time -= 1
  	// 	if(this.last_time == 0) {
  	// 		clearInterval(itv)
  	// 		this.$router.push({
  	// 			path: '/newduixiang'
  	// 		})
  	// 	}
  	// }, 1000)
  },
  data(){
  	return {
  		msg: '欢迎进入微格子云表格后台管理系统',
  		last_time: 3
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
